var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionDot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 13,
    viewBox: "0 0 3 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.72656C0 7.12439 0.158036 7.50592 0.43934 7.78722C0.720645 8.06853 1.10218 8.22656 1.5 8.22656C1.89782 8.22656 2.27936 8.06853 2.56066 7.78722C2.84196 7.50592 3 7.12439 3 6.72656C3 6.32874 2.84196 5.94721 2.56066 5.6659C2.27936 5.3846 1.89782 5.22656 1.5 5.22656C1.10218 5.22656 0.720645 5.3846 0.43934 5.6659C0.158036 5.94721 0 6.32874 0 6.72656ZM0 2.22656C0 2.62439 0.158036 3.00592 0.43934 3.28722C0.720645 3.56853 1.10218 3.72656 1.5 3.72656C1.89782 3.72656 2.27936 3.56853 2.56066 3.28722C2.84196 3.00592 3 2.62439 3 2.22656C3 1.82874 2.84196 1.44721 2.56066 1.1659C2.27936 0.884598 1.89782 0.726563 1.5 0.726562C1.10218 0.726563 0.720645 0.884598 0.43934 1.1659C0.158036 1.44721 0 1.82874 0 2.22656ZM0 11.2266C0 11.6244 0.158036 12.0059 0.43934 12.2872C0.720645 12.5685 1.10218 12.7266 1.5 12.7266C1.89782 12.7266 2.27936 12.5685 2.56066 12.2872C2.84196 12.0059 3 11.6244 3 11.2266C3 10.8287 2.84196 10.4472 2.56066 10.1659C2.27936 9.8846 1.89782 9.72656 1.5 9.72656C1.10218 9.72656 0.720645 9.8846 0.43934 10.1659C0.158036 10.4472 0 10.8287 0 11.2266Z",
    fill: "#3DA298"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionDot);
export default __webpack_public_path__ + "static/media/optionDot.81b3f800c46910e98692d45276fa26a4.svg";
export { ForwardRef as ReactComponent };